import script from "./ColivingNaturalSearchWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ColivingNaturalSearchWidget.vue?vue&type=script&setup=true&lang=js"

import "./ColivingNaturalSearchWidget.vue?vue&type=style&index=0&id=1a3c1bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3c1bce"]])

export default __exports__